/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The requesting agent's access given by sharing: `edit` when they hold the edit access (`editorUserGuid`), `read_only` otherwise - the owner while someone else edits, or anyone the analysis was ever shared with who does not hold it. Writes without the edit access fail with 403 `analysis_read_only_access`
 */
export type AnalysisDetailAccessMode = (typeof AnalysisDetailAccessMode)[keyof typeof AnalysisDetailAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalysisDetailAccessMode = {
  edit: "edit",
  read_only: "read_only",
} as const;
